export const projects = [
  {
    name: 'Team Tasks',
    description:
      'Team Tasks is a task list application created with React, TypeScript and Firestore. Feature include basic CRUD functionality, drag and drop, livesharing, authentication and offline persistence.',
    technologyUsed: 'React, TypeScript, Firestore, Styled-Components, React Beautful DnD, HTML, CSS, JavaScript',
    gitHubLink: 'https://github.com/carlorre/new-firebase-todo',
    liveDemo: 'https://team-tasks.netlify.app',
    media: './media/teamtasks_gif.gif',
  },
  {
    name: 'Come Chat Me',
    description:
      'Chat application built using React, Redux for state management, socket.io and an Express server. The application was built using a mobile first approach and is fully responsive. Sign in on two different browsers to test the functionality.',
    technologyUsed: 'React, Redux, Socket.io, Express, HTML, CSS, TypeScript',
    gitHubLink: 'https://github.com/carlorre/comechatme-client-ts',
    liveDemo: 'https://comechatme.netlify.app',
    media: './media/chat_gif.gif',
  },
   {
    name: 'Tappy',
    description:
      'Worked on a 5 person team to create a MVP for a startup in two weeks. The app uses Firebase for live database updates, user authentication and storage. The app uses Stripe to handle payments.',
    technologyUsed: 'React Native, Expo, Firebase, Stripe, HTML, CSS, JavaScript',
    gitHubLink: 'https://github.com/Mobbishly/TappyPublic',
    video: '472431255',
    media: './media/tappy_gif.gif',
  },
   {
    name: 'Trash Tagger',
    description:
      'Mobile application made with React Native and Firebase. The concept of the app is to allow users to geo-tag areas in need of clean up and share photos of successful clean ups. The app uses Google Maps API for geo-tagging and Google Vision for image moderation.',
    technologyUsed: 'React Native, Expo, Firebase, Google Cloud Platform, HTML, CSS, JavaScript',
    gitHubLink: 'https://github.com/Mobbishly/TrashTagger',
    video: '472432541',
    media: './media/trashtagger_logo.png',
  },
  {
    name: 'Custom Memory Game',
    description:
      'Fun little memory game created in React which allows users to chose the theme of the game. This project demonstrates the ability to use an external API to modify content dynamically. The game fetches images from the Unsplash API based on user input.',
    technologyUsed: 'React(hooks), Unsplash API, HTML, CSS, JavaScript',
    gitHubLink: 'https://github.com/carlorre/react_memory',
    liveDemo: 'https://custommemorygame.netlify.app',
    media: './media/memory_gif.gif',
  },
  {
    name: 'Todo List',
    description:
      'My first React App! Although the project is relatively simple it demonstrates the ability to use React classes as well as local storage. Special attention was given to accessibility and the app can be operated using only the keyboard. It is fully responsive. ',
    technologyUsed: 'React(classes), Local Storage, HTML, CSS, JavaScript',
    gitHubLink: 'https://github.com/carlorre/react-todo',
    liveDemo: 'https://todoloo.netlify.app',
    media: './media/todo_gif.gif',
  },
  {
    name: 'Portfolio',
    description:
      'My personal portfolio page built with React which is used as a platform to display my work. The application is hosted on Netlify and is fully responsive. It has a dark mode feature that persists using local storage.',
    technologyUsed: 'React, Local Storage, HTML, CSS, JavaScript',
    gitHubLink: 'https://github.com/carlorre/portfolio',
    media: './media/portfolio.png',
  },
];
